import * as api from 'dashboard/resources/chain-sales-rank.api';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import chainSalesRankWidgetTemplate from './chain-sales-rank-widget.html';

const mapStateToThis = ({ session, dictionary }) => {
  const { locale, retailer } = session;
  const terms = dictionary.terms[locale];

  return {
    userLocale: locale,
    retailer,
    terms,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class ChainSalesRankWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchChainSalesRank(retailerId));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class ChainSalesRankWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.controller = ChainSalesRankWidgetController;
    this.template = chainSalesRankWidgetTemplate;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/chain-sales-rank/chain-sales-rank-widget-component.js